/* pantallas-alumno (D), P12 de la parte 1 (firma del 19-oct): LA CUADRICULA DEL EXAMEN SE DESPLAZA SOLA HASTA LA
   PREGUNTA ACTUAL, al abrirse y al cambiar de pregunta (la fija de computadora y la hoja "Jump to question").

   ARCHIVO EN ASCII A PROPOSITO (regla de la casa para los `.js` nuevos).

   POR QUE NO `scrollIntoView` (la opcion `desplazarALaActual` de la pieza `CuadriculaDeSalto`): `scrollIntoView`
   desplaza TODAS las cajas que lo contienen hasta dejar el boton a la vista, la pagina incluida. Con una pregunta larga
   la cuadricula fija queda abajo de la vista, y cambiar de pregunta con las flechas del teclado (o el primer pintado)
   bajaria la pagina entera. Aqui solo se mueve la caja de la cuadricula: su `scrollTop`, lo justo para que la actual
   quede a la vista ("nearest"). La caja tiene que ser el contenedor de posicion de sus botones (posicion relativa), asi
   `offsetTop` se mide desde ella. */
import { useEffect } from 'react';
import { reducirMovimiento } from '../components/panel/useReacomodo';

/** Mueve SOLO `caja` (su scrollTop) para que `boton` quede a la vista. No toca la pagina. */
export function desplazarDentroDeLaCaja(caja, boton, suave = false) {
  if (!caja || !boton) return;
  const arriba = Number(boton.offsetTop) || 0;
  const abajo = arriba + (Number(boton.offsetHeight) || 0);
  const visto = Number(caja.scrollTop) || 0;
  const alto = Number(caja.clientHeight) || 0;
  let destino = null;
  if (arriba < visto) destino = arriba;
  else if (abajo > visto + alto) destino = abajo - alto;
  if (destino == null || destino === visto) return;
  if (suave && typeof caja.scrollTo === 'function') {
    try { caja.scrollTo({ top: destino, behavior: 'smooth' }); return; } catch { /* abajo, sin animacion */ }
  }
  caja.scrollTop = destino;
}

/** Al montarse y cada vez que cambia `actual`: la caja de `cajaRef` se desplaza hasta su boton actual (el que lleva
    `aria-current`, como lo pinta `CuadriculaDeSalto`). Con "reducir movimiento", sin animacion. */
export function useDesplazarALaActual(cajaRef, actual, activo = true) {
  useEffect(() => {
    if (!activo) return;
    const raiz = cajaRef.current;
    if (!raiz || typeof raiz.querySelector !== 'function') return;
    const boton = raiz.querySelector('[aria-current="step"]');
    const caja = boton ? boton.parentElement : null;
    desplazarDentroDeLaCaja(caja, boton, !reducirMovimiento());
  }, [cajaRef, actual, activo]);
}
